import { createAsyncThunk } from '@reduxjs/toolkit';
import { AppDispatch, RootState } from './store';

export const createAppThunk = createAsyncThunk.withTypes<{ state: RootState; dispatch: AppDispatch }>();
export default createAppThunk;
